import { useTransitionStyles } from "@floating-ui/react";
export const useTransition = (context) => {
    return useTransitionStyles(context, {
        duration: {
            open: 200,
            close: 200,
        },
        initial: {
            opacity: 0,
        },
    });
};
